




import Vue from 'vue';
export default Vue.extend({
  computed: {
    email() {
      return (this as any).params && (this as any).params.value;
    },
  },
});
